export const getSectionPreviousPages = (pdfPagesPerSection, sections) =>
  sections.reduce((acc, section) => acc + pdfPagesPerSection[section], 0)
